import React, { useContext } from "react";
import { ContentContext } from "../contexts/ContentContext";
import { FiCheckCircle } from "react-icons/fi";

export default function Certifications() {
    const { data } = useContext(ContentContext);
    const c = data.certifications;
    if (!c || !c.items) return null;

    return (
        <section className="py-16 md:py-20 bg-white border-t border-navy-100">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="max-w-2xl mb-10">
                    <div className="inline-flex items-center gap-3 mb-3">
                        <span className="h-px w-10 bg-gold-500" />
                        <span className="text-xs font-bold text-brand-emerald tracking-[0.22em] uppercase">
                            {c.eyebrow}
                        </span>
                    </div>
                    <h2 className="font-serif text-2xl md:text-3xl font-bold text-navy-900 leading-tight mb-2">
                        {c.title}
                    </h2>
                    <p className="text-base text-navy-700/80">{c.subtitle}</p>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                    {c.items.map((it, i) => (
                        <div
                            key={i}
                            className="flex flex-col items-center text-center p-4 rounded-2xl border border-navy-100 bg-navy-50 hover:border-gold-300 transition"
                        >
                            <FiCheckCircle className="w-7 h-7 text-brand-emerald mb-2" />
                            <div className="font-serif font-bold text-navy-900 text-sm leading-tight">
                                {it.name}
                            </div>
                            <div className="text-xs text-navy-700/70 mt-1">{it.desc}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
